import enCore from "@/i18n/locales/en/core.json";
import enAdministration from "@/i18n/locales/en/administration.json";
import enOperations from "@/i18n/locales/en/operations.json";
import enSystem from "@/i18n/locales/en/system.json";
import enTools from "@/i18n/locales/en/tools.json";

import esCore from "@/i18n/locales/es/core.json";
import esAdministration from "@/i18n/locales/es/administration.json";
import esOperations from "@/i18n/locales/es/operations.json";
import esSystem from "@/i18n/locales/es/system.json";
import esTools from "@/i18n/locales/es/tools.json";

export const enTranslation = {
  ...enCore,
  ...enAdministration,
  ...enOperations,
  ...enSystem,
  ...enTools,
};

export const esTranslation = {
  ...esCore,
  ...esAdministration,
  ...esOperations,
  ...esSystem,
  ...esTools,
};
